import React from 'react';
import {Box, LinearProgress, Typography} from '@mui/material';
import './ArrLinearProgressBar.scss';
import {t} from 'i18next';

interface ArrLinearProgressBarProps {
  completed: number;
  total: number;
  label?: string;
  id?: number;
}

const ArrLinearProgressBar: React.FC<ArrLinearProgressBarProps> = ({
  completed,
  total,
  label,
  id,
}) => {
  const progress = total > 0 ? (completed / total) * 100 : 0;

  const renderDefaultLabel = () => (
    <span
      className="typo-text body3_size progress-label"
      data-testid={`arr-linear-progress-bar-progress-of-progress-suffix-default-label-${id}`}
    >
      <span
        className="typo-text label2_size"
        data-testid={`arr-linear-progress-bar-span`}
      >
        {completed}
      </span>{' '}
      {t('common.linearProgressBar.progress_of')}{' '}
      <span
        className="typo-text label2_size"
        data-testid={`arr-linear-progress-bar-span-text`}
      >
        {total}
      </span>{' '}
      {t('common.linearProgressBar.progress_suffix')}
    </span>
  );

  return (
    <Box className="linear-progress-bar">
      <Typography
        className="typo-text body3_size progress-label"
        data-testid={`${id}-label`}
      >
        {label || renderDefaultLabel()}
      </Typography>

      <LinearProgress
        variant="determinate"
        value={progress}
        data-testid={`progress-${id}`}
        className="custom-linear-progress"
      />
    </Box>
  );
};

export default ArrLinearProgressBar;
